<div [ngClass]="{
    'toastVisible': toastVisible,
    'inline-toast inline-toast-success': true }">
    <p>
        <i class="fa-solid fa-circle-check"></i>
        <ng-content></ng-content>
    </p>
</div>